// // src/features/counterSlice.js

// import { createSlice } from "@reduxjs/toolkit";

// export const loaderslice = createSlice({
//   name: "loader",
//   initialState: {
//     open: false,
//   },
//   reducers: {
//     openLoader(state, action) {
//       state.open = true;
//     },
//     closeLoader(state) {
//       state.open = false;
//     },
//   },
// });

// export const { openLoader, closeLoader } = loaderslice.actions;

// export default loaderslice.reducer;
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
};

export const loaderSlice = createSlice({
  name: 'loader',
  initialState,
  reducers: {
    startLoading: (state) => {
      state.isLoading = true;
    },
    stopLoading: (state) => {
      state.isLoading = false;
    },
  },
});

export const { startLoading, stopLoading } = loaderSlice.actions;
export default loaderSlice.reducer;